"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserProfileService = void 0;
var React = require("react");
var immer_1 = require("immer");
var urls_1 = require("../urls");
var UserProfileRestData_1 = require("../rest/UserProfileRestData");
var RestData_1 = require("../rest/RestData");
var initial_data = {
    id: undefined,
    user_id: undefined,
    first_name: undefined,
    last_name: undefined,
    company: undefined,
    area_of_expertise: undefined,
    email: undefined,
    telephone: undefined,
    language: undefined,
    timezone: undefined,
    job_position: undefined,
    picture_url: undefined,
    is_superuser: undefined,
    is_staff: undefined,
    confirmation_sent: undefined,
};
var UserProfileAction;
(function (UserProfileAction) {
    UserProfileAction["CHANGE_DATA"] = "CHANGE_DATA";
})(UserProfileAction || (UserProfileAction = {}));
function user_profile_data_reducer(state, action) {
    if (action.type == RestData_1.DataActionType.READ_POST) {
        return action.payload;
    }
    if (action.type == RestData_1.DataActionType.UPDATE_POST) {
        if (action.payload.confirmation_sent) {
            notification(gettext("Please check your email to confirm change of address."));
        }
        return action.payload;
    }
    if (action.type == UserProfileRestData_1.UserProfileDataActionType.PASSWORD_CHANGED) {
        notification(gettext("Password was changed successfully"));
        return (0, immer_1.default)(state, function (draft) {
            draft.old_password = undefined;
            draft.new_password1 = undefined;
            draft.new_password2 = undefined;
        });
    }
    if (action.type == UserProfileRestData_1.UserProfileDataActionType.PICTURE_CHANGED) {
        notification(gettext("Picture successfully saved"));
        return action.payload;
    }
    if (action.type == UserProfileAction.CHANGE_DATA) {
        return (0, immer_1.default)(state, function (draft) {
            draft[action.name] = action.value;
        });
    }
    return state;
}
var useUserProfileService = function (user_id) {
    var _a = __read(React.useReducer(user_profile_data_reducer, initial_data), 2), profile = _a[0], dispatch = _a[1];
    var rest_svc = (0, UserProfileRestData_1.useUserProfileRestData)((0, urls_1.resolve)(urls_1.Urls.user_profile, user_id), dispatch);
    function update_profile(name, value) {
        dispatch({
            type: UserProfileAction.CHANGE_DATA,
            payload: undefined,
            name: name,
            value: value,
        });
    }
    function save_profile() {
        var profile_data = {
            first_name: profile.first_name,
            last_name: profile.last_name,
            company: profile.company,
            area_of_expertise: profile.area_of_expertise,
            email: profile.email,
            telephone: profile.telephone,
            language: profile.language,
            timezone: profile.timezone,
            job_position: profile.job_position,
        };
        rest_svc.update(profile_data);
    }
    function change_password() {
        rest_svc.change_password(profile.old_password, profile.new_password1, profile.new_password2);
    }
    return [
        profile,
        {
            retrieve: rest_svc.read,
            save: save_profile,
            update: update_profile,
            set_picture: rest_svc.set_picture,
            change_password: change_password,
        },
    ];
};
exports.useUserProfileService = useUserProfileService;
